import PropTypes from "prop-types";

export const ModuleHeader = ({ title, subtitle }) => {
  return (
    <div className="admin-header">
      <h1 className="admin-title">{title}</h1>
      <p className="admin-subtitle">{subtitle}</p>
    </div>
  );
};

ModuleHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};
